
import { Component, Vue, VModel } from 'vue-property-decorator';
import { AuditCustomFieldGroupModel, AuditCustomFieldModel, CustomFieldTypeEnum, CustomFieldGroupTypeEnum } from '@/libs/Api';

@Component
export default class AuditCustomFieldGroupList extends Vue {
    @VModel({ type: Array, required: true }) groups!: AuditCustomFieldGroupModel[];

    CustomFieldGroupTypeEnum = CustomFieldGroupTypeEnum;

    get fieldTypeOptions() {
        return [
            { value: CustomFieldTypeEnum.String, text: this.$t('audits.customFields.typeString') },
            { value: CustomFieldTypeEnum.Integer, text: this.$t('audits.customFields.typeInteger') },
            { value: CustomFieldTypeEnum.Double, text: this.$t('audits.customFields.typeDouble') },
            { value: CustomFieldTypeEnum.Date, text: this.$t('audits.customFields.typeDate') },
            { value: CustomFieldTypeEnum.DateTime, text: this.$t('audits.customFields.typeDateTime') },
            { value: CustomFieldTypeEnum.Boolean, text: this.$t('audits.customFields.typeBoolean') },
            { value: CustomFieldTypeEnum.TextArea, text: this.$t('audits.customFields.typeTextArea') },
        ];
    }

    get groupTypeOptions() {
        return [
            { value: 'General', text: this.$t('audits.customFields.groupTypeGeneral') },
            { value: 'Process', text: this.$t('audits.customFields.groupTypeProcess') },
            { value: 'Other', text: this.$t('audits.customFields.groupTypeOther') },
        ];
    }

    addGroup() {
        const maxPosition = (this.groups || []).reduce(
            (max, g) => (typeof g.position === 'number' && g.position > max ? g.position : max),
            0
        );
        const newGroup: AuditCustomFieldGroupModel = {
            id: undefined,
            name: '',
            auditCustomFields: [],
            auditId: undefined,
            createdAt: undefined,
            createdById: undefined,
            tenantId: undefined,
            isDeleted: false,
            position: maxPosition + 1,
        };
        this.groups = [...(this.groups || []), newGroup];
    }

    addField(group: AuditCustomFieldGroupModel) {
        const maxPosition = (group.auditCustomFields || []).reduce(
            (max, f) => (typeof f.position === 'number' && f.position > max ? f.position : max),
            0
        );
        const newField: AuditCustomFieldModel = {
            id: undefined,
            name: '',
            type: CustomFieldTypeEnum.String,
            title: '',
            placeholder: '',
            auditCustomFieldGroupId: group.id,
            createdAt: undefined,
            createdById: undefined,
            tenantId: undefined,
            isDeleted: false,
            position: maxPosition + 1,
            isRequired: false,
        };
        group.auditCustomFields = [...(group.auditCustomFields || []), newField];
        this.groups = [...(this.groups || [])];
    }

    removeField(group: AuditCustomFieldGroupModel, fieldIdx: number) {
        if (!group.auditCustomFields) return;
        group.auditCustomFields.splice(fieldIdx, 1);
        this.groups = [...(this.groups || [])];
    }

    removeGroup(groupIdx: number) {
        this.groups.splice(groupIdx, 1);
        this.groups = [...(this.groups || [])];
    }

    moveGroupUp(idx: number) {
        if (idx <= 0) return;
        const arr = [...this.groups];
        [arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]];
        arr.forEach((g, i) => {
            g.position = i + 1;
        });
        this.groups = arr;
    }

    moveGroupDown(idx: number) {
        if (idx >= this.groups.length - 1) return;
        const arr = [...this.groups];
        [arr[idx], arr[idx + 1]] = [arr[idx + 1], arr[idx]];
        arr.forEach((g, i) => {
            g.position = i + 1;
        });
        this.groups = arr;
    }

    moveFieldUp(group: AuditCustomFieldGroupModel, idx: number) {
        if (!group.auditCustomFields || idx <= 0) return;
        const arr = [...group.auditCustomFields];
        [arr[idx - 1], arr[idx]] = [arr[idx], arr[idx - 1]];
        arr.forEach((f, i) => {
            f.position = i + 1;
        });
        group.auditCustomFields = arr;
        this.groups = [...(this.groups || [])];
    }

    moveFieldDown(group: AuditCustomFieldGroupModel, idx: number) {
        if (!group.auditCustomFields || idx >= group.auditCustomFields.length - 1) return;
        const arr = [...group.auditCustomFields];
        [arr[idx], arr[idx + 1]] = [arr[idx + 1], arr[idx]];
        arr.forEach((f, i) => {
            f.position = i + 1;
        });
        group.auditCustomFields = arr;
        this.groups = [...(this.groups || [])];
    }
}
